import {
  RvsfFormValue,
  RvsfRequest,
  RvsfResponse,
} from '../models/rvsf-list.model';

export class RvsfMapper {
  // API → Form
  static toForm(apiData: RvsfResponse['data']): RvsfFormValue {
    return {
      id: apiData.rvsf_id,
      name: apiData.rvsf_name || '',
      logoPath: apiData.rvsf_logo_path || '',
      faviconPath: apiData.rvsf_fevicon_path || '',
      legalName: apiData.rvsf_legal_name || '',
      mobileNumber: apiData.rvsf_contact_mobile_no || '',
      emailId: apiData.rvsf_contact_email_id || '',
      addressLine1: apiData.rvsf_address_line_1 || '',
      addressLine2: apiData.rvsf_address_line_2 || '',
      pincode: apiData.pincode || null,
      rvsf_pincode_id: apiData.rvsf_pincode_id,
      landingPageImage: apiData.landing_page_image_path || '',
      landingPageAboutText: apiData.landing_page_about_us_text || '',
      accessUrl: apiData.access_url || '',
      isActive: apiData.is_active ?? true,
    };
  }

  // Form → API Request
  static toRequest(formValue: RvsfFormValue): RvsfRequest {
    return {
      rvsf_id: formValue.id ?? 0,
      rvsf_name: formValue.name.trim(),
      rvsf_logo_path:
        typeof formValue.logoPath === 'string' ? formValue.logoPath.trim() : '',
      rvsf_fevicon_path:
        typeof formValue.faviconPath === 'string'
          ? formValue.faviconPath.trim()
          : '',
      rvsf_legal_name: formValue.legalName.trim(),
      rvsf_contact_mobile_no: formValue.mobileNumber.trim(),
      rvsf_contact_email_id: formValue.emailId.trim(),
      rvsf_address_line_1: formValue.addressLine1.trim(),
      rvsf_address_line_2: formValue.addressLine2?.trim() || '',
      rvsf_pincode_id: Number(formValue.pincode) || 0,
      landing_page_image_path:
        typeof formValue.landingPageImage === 'string'
          ? formValue.landingPageImage.trim()
          : '',
      landing_page_about_us_text: formValue.landingPageAboutText.trim(),
      access_url: formValue.accessUrl?.trim() || '',
      is_active: formValue.isActive ?? true,
    };
  }
}
